<div class="text-center">
    <h6 class="m-0 pb-16" style="white-space: pre-wrap; line-height: 1.4;">{{ title?title:'Processando...' }}</h6>
    <div mat-dialog-content>
        <div fxLayout="column" fxLayoutAlign="end center">
            <mat-progress-spinner *ngIf="!finished" class="example-margin" [color]="color" [mode]="mode" [value]="value"></mat-progress-spinner>
            <!-- <button mat-raised-button type="button" class="ml-16 mr-16" (click)="close()" *ngIf="finished">
                OK
            </button> -->
            <button mat-raised-button type="button" class="ml-16 mr-16" (click)="close()" >
                OK
            </button>
        </div>
    </div>
</div>
